// extracted by mini-css-extract-plugin
module.exports = {"searchFormContainer":"SearchFormWrapper_searchFormContainer__qons5","emptyInput":"SearchFormWrapper_emptyInput__2rBja","fullInput":"SearchFormWrapper_fullInput__39sOR"};